export default __webpack_public_path__ + "static/media/Whitechip.a2bf3306.svg";